import Carousel from "@components/carousel/FestivalTimelineCarousel";
import LoadingCircle from "@components/loadings/LoadingCircle";
import { getEncyclopediaEvents } from "@queries/festivalTimeline.queries";
import styles from "@styles/timeline/festivalTimeline.module.css";
import { getTime } from "@utils/events/helpers";
import Image from "next/legacy/image";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";
export default function FestivalTimeline() {
  const {
    t
  } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [timeline, setTimeline] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  useEffect(() => {
    async function getData() {
      const {
        data,
        err
      } = await getEncyclopediaEvents({
        date: 0
      });
      if (data && !err) {
        setTimeline(data);
      }
      setIsLoading(false);
    }
    getData();
  }, []);
  const updateTimelineData = async () => {
    let date = null;
    if (timeline?.length > 0) date = timeline[timeline.length - 1].date;else return () => {};
    const res = await getEncyclopediaEvents({
      date: date
    });
    if (res?.data?.length !== 0 && !res.err) {
      setTimeline(cur => cur.concat(res.data));
    } else setHasMore(false);
  };
  function renderTimeline(item, index) {
    return <FestivalTimelineItem key={index.toString()} data={item} data-sentry-element="FestivalTimelineItem" data-sentry-component="renderTimeline" data-sentry-source-file="FestivalTimeline.jsx" />;
  }
  if (isLoading) {
    return <p style={{
      textAlign: "center"
    }}>{t('loading')}</p>;
  }
  if (timeline?.length > 0) {
    return <div className={styles.timeline_root}>
        {/* {timeline.map((item, idx) => (
         <FestivalTimelineItem key={idx.toString()} data={item} />
         ))} */}
        <InfiniteScroll dataLength={timeline.length} next={updateTimelineData} hasMore={hasMore} loader={<LoadingCircle />}>
          {timeline.map(renderTimeline)}
        </InfiniteScroll>
      </div>;
  }
  return null;
}
function FestivalTimelineItem({
  data
}) {
  const env = process.env.NEXT_PUBLIC_MEDIA_DEV_DOMAIN;
  let link = data.images[0];
  function myFunction(item) {
    if (item.length === 0) return item;else {
      const replace = item.replace(item.slice(0, 36), env);
      return replace;
    }
  }
  const REF = useRef(null);
  useEffect(() => {
    if (REF.current && data.position != -1) {
      const top = REF.current.offsetTop;
      if (top) window.scrollTo(0, top);
    }

    // eslint-disable-next-line
  }, [REF]);
  return <div className={`${styles.container}`} ref={REF} data-sentry-component="FestivalTimelineItem" data-sentry-source-file="FestivalTimeline.jsx">
      <div className={styles.content}>
        <span>{getTime(data.date).slice(0, 15)}</span>
        <h2>{data.title}</h2>
        <p>{data.description}</p>
      </div>
      {data?.images?.length >= 2 ? <div className={styles.timelineImage}>
        {/* <Image
          alt={data.title}
          src={data.images[0] || puja}
          height={200}
          width={300}
         /> */}
          {/* <SimpleImageSlider 
            width={300}
            height={200}
            images={data.images}
            style={{
              borderRadius:"20px"
            }}
            showNavs={true}
           /> */}
           <Carousel data={data} />
                
      </div> : <>
        {data?.images?.length === 1 && link && <div className={styles.timelineSingleImage}>
          <Image src={link} alt={t('utsav-home-carousel-image')} width={320} height={180}
        // layout="fill"
        objectFit="cover"
        // priority
        />
          </div>}
          </>}

    </div>;
}